import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeSetLike, meshGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {MeshGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {MergeOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/merge-operator/geometry-merge-operator-node"
import {
    GeometryMergeOperatorNode,
    mergeOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/merge-operator/geometry-merge-operator-node"

export type MeshGeometryMergeOperatorParameters = MergeOperatorParameters<MeshGeometryAttributeSetLikeNode>

const definition: TemplateNodeDefinition<MeshGeometryMergeOperatorParameters> = {
    nodeClass: "MeshGeometryMergeOperator",
    validation: {
        parameters: mergeOperatorParametersSchema(meshGeometryAttributeSetLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryMergeOperator extends GeometryMergeOperatorNode<2, MeshGeometryAttributeSetLikeNode> implements MeshGeometryAttributeSetLikeNode {
    get [meshGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
